// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.module.css or your CSS file */
.popupButton {
    padding: 12px 20px;
    width: 100%;
    text-align: center;
    display: flex;
    height: auto;
    min-height: 40px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    font-family: "balto", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    letter-spacing: .6px;
    text-transform: uppercase;
    border-radius: 50px;
    border: 2px solid #FFFFFF;
    background: #e71d2e;
    color: #fff;
    text-decoration: none;
    transition: all .3s ease;
    cursor: pointer;
}

.popupButton:hover {
    background: #164fd7;
    color: #164fd7;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(231, 29, 46, 0.2);
}

.popupButton:active {
    transform: translateY(0);
}

/* Media queries */
@media (min-width: 768px) {
    .popupButton {
        font-size: 18px;
        padding: 12px 24px;
        gap: 10px;
    }
}

@media (min-width: 1024px) {
    .popupButton {
        font-size: 20px;
        padding: 12px 12px;
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/popupBanner.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,kBAAkB;AAClB;IACI;QACI,eAAe;QACf,kBAAkB;QAClB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;QAClB,WAAW;IACf;AACJ","sourcesContent":["/* styles.module.css or your CSS file */\n.popupButton {\n    padding: 12px 20px;\n    width: 100%;\n    text-align: center;\n    display: flex;\n    height: auto;\n    min-height: 40px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    font-family: \"balto\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 100%;\n    letter-spacing: .6px;\n    text-transform: uppercase;\n    border-radius: 50px;\n    border: 2px solid #FFFFFF;\n    background: #e71d2e;\n    color: #fff;\n    text-decoration: none;\n    transition: all .3s ease;\n    cursor: pointer;\n}\n\n.popupButton:hover {\n    background: #164fd7;\n    color: #164fd7;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(231, 29, 46, 0.2);\n}\n\n.popupButton:active {\n    transform: translateY(0);\n}\n\n/* Media queries */\n@media (min-width: 768px) {\n    .popupButton {\n        font-size: 18px;\n        padding: 12px 24px;\n        gap: 10px;\n    }\n}\n\n@media (min-width: 1024px) {\n    .popupButton {\n        font-size: 20px;\n        padding: 12px 12px;\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
